import React, { createContext, useState } from "react";

// Context 
export const DealersContext = createContext();

// Context provider bileşeni
export const DealersProvider = ({ children }) => {
  // Bayiler listesi state'i
  const [dealersList, setDealersList] = useState([
    { name: "X Bayi", status: "Aktif", id: 1 },
    { name: "Y Bayi", status: "Pasif", id: 2 },
  ]);

  // Yeni bayi ekleme fonksiyonu
  const addDealer = (dealer) => {
    // Yeni bayi ID'si belirleniyor (mevcut en yüksek ID + 1)
    const newId =
      dealersList.length > 0 ? Math.max(...dealersList.map((d) => d.id)) + 1 : 1;
    // Yeni bayi listeye ekleniyor
    setDealersList((prev) => [...prev, { ...dealer, id: newId }]);
  };

  // Mevcut bayiyi güncelleme fonksiyonu
  const updateDealer = (id, updatedData) => {
    setDealersList((prev) =>
      prev.map((d) => (d.id === id ? { ...d, ...updatedData } : d))
    );
  };

  // Bayiyi silme fonksiyonu
  const deleteDealer = (id) => {
    setDealersList((prev) => prev.filter((d) => d.id !== id));
  };

  // Provider ile context değerleri paylaşılıyor
  return (
    <DealersContext.Provider
      value={{
        dealersList,  
        addDealer,    
        updateDealer,  
        deleteDealer,  
      }}
    >
      {children} 
    </DealersContext.Provider>
  );
};
